import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EDSFiltersRequestBody } from '@/features/eds/types/api/requests/EDSFiltersRequestBody';
import { EdsSortingRequest } from '@/features/eds/types/api/requests/EdsSortingRequestBody';
import { CreateCoverageRequest } from '../types/api/requests/CreateCoverageRequest';
import { LinkCoverageRequest } from '../types/api/requests/LinkCoverageRequest';
import { GetCoveragesListResponse } from '../types/api/responses/GetCoveragesListResponse';
import { coverageSliceInitialState } from './constants/coverageSliceConstants';

const coveragesSlice = createSlice({
  name: 'coverages',
  initialState: coverageSliceInitialState,
  reducers: {
    createCoverage: (_state, _action: PayloadAction<CreateCoverageRequest>) => {},
    getCoveragesFilteredList: (state) => {
      state.statuses.isLoading = true;
      state.data.pagination = coverageSliceInitialState.data.pagination;
    },
    getCoveragesListFailed: (state) => {
      state.statuses.isLoading = false;
    },
    getCoveragesListSuccess: (
      state,
      {
        payload: { shouldRewrite = true, data },
      }: PayloadAction<{ data: GetCoveragesListResponse; shouldRewrite?: boolean }>,
    ) => {
      if (shouldRewrite) {
        state.data.listings = [...data.listings];
        state.data.pagination = data.pagination;
      } else {
        state.data.listings = [...state.data.listings, ...data.listings];
        state.data.pagination = data.pagination;
      }

      state.statuses.isLoading = false;
    },
    incrementCoveragesListPage: (state) => {
      state.data.pagination.page++;
    },
    resetCoveragesSlice: () => coverageSliceInitialState,
    linkCoverageToClaim: (_, _action: PayloadAction<LinkCoverageRequest>) => {},
    unlinkCoverageFromClaim: (_, _action: PayloadAction<LinkCoverageRequest>) => {},
    updateCoveragesSavedFiltersForSending: (state, { payload }: PayloadAction<EDSFiltersRequestBody>) => {
      state.savedFiltersForSending = payload;
    },
    updateCoveragesSavedSortingForSending: (state, { payload }: PayloadAction<EdsSortingRequest>) => {
      state.savedSortingForSending = payload;
    },
    deleteCoverage: (_, _action: PayloadAction<number>) => {},
  },
});

export const {
  createCoverage,
  getCoveragesFilteredList,
  getCoveragesListFailed,
  getCoveragesListSuccess,
  incrementCoveragesListPage,
  resetCoveragesSlice,
  linkCoverageToClaim,
  unlinkCoverageFromClaim,
  updateCoveragesSavedFiltersForSending,
  updateCoveragesSavedSortingForSending,
  deleteCoverage,
} = coveragesSlice.actions;

export const coveragesReducer = coveragesSlice.reducer;
export const coveragesReducerPath = coveragesSlice.reducerPath;
